import { render, staticRenderFns } from "./ListPageMaintenanceRequests.vue?vue&type=template&id=36e7f2d0"
import script from "./ListPageMaintenanceRequests.vue?vue&type=script&lang=js"
export * from "./ListPageMaintenanceRequests.vue?vue&type=script&lang=js"
import style1 from "./ListPageMaintenanceRequests.vue?vue&type=style&index=1&id=36e7f2d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports